export default __webpack_public_path__ + "static/media/love_no_bg.20e38e9b.png";